import React from "react";
import { Helmet } from "react-helmet-async";

import {
  About,
  Services,
  Footer,
  Header,
  Skills,
  Testimonial,
  Work,
  Blog,
  Team,
  Store,
} from "./container";
import Internship from "./container/Internship/Internship";
import Community from "./container/Community/Community";
import InvestorHub from "./container/InvestorHub/InvestorHub";
import AIVentures from "./container/AIVentures/AIVentures";
import { Navbar } from "./components";
import ProjectBanner from "./components/ProjectBanner/ProjectBanner";
import "./App.css";

/**
 * Section order and surface tone alternate deliberately: warm paper carries the
 * narrative sections, plain paper the dense ones, and ink the two moments that
 * deserve full stop — the flagship ventures and the close.
 */
const Home = () => (
  <div className="app relative bg-paper">
    <Helmet>
      <title>Hyphen Tech | Digital Transformation & AI Solutions in Africa</title>
      <meta
        name="description"
        content="Hyphen Tech catalyzes digital transformation in Africa through elite-level engineering and artificial intelligence, building scalable ecosystems that solve critical economic and social challenges."
      />
      <link rel="canonical" href="https://hyphentech.africa/" />
    </Helmet>

    <ProjectBanner />
    <Navbar />

    <main>
      <Header />
      <About />
      <Services />
      <AIVentures />
      <InvestorHub />
      <Work />
      <Skills />
      <Team />
      <Internship />
      <Blog />
      <Store />
      <Community />
      <Testimonial />
    </main>

    <Footer />
  </div>
);

export default Home;
